export default __webpack_public_path__ + "static/media/fridge2-afterA-768w.f871d2bb.png";